<template>
    <div class="layout">
        <Header></Header>
       
        <div style="display: flex; background-color: #012430;padding-top: 10px;justify-content: space-between;min-width: 1758px;">
             <!-- 左侧导航 -->
            <div class="menu">
                <Menu :supplierinfo="supplierinfo"></Menu>
            </div>
              <!-- 右侧内容 -->
            <div class="content">
                <Content></Content>
            </div>
        </div>
       
      
    </div>
</template>

<script>
import Menu from './menu/Index.vue'
import Content from './content/Index.vue'
import Header from './content/Header.vue'

export default {
    components: {
        Menu,
        Content,
        Header
    },
    data(){
        return{
            supplierinfo:{},
        }
    },
    created(){
       this.getdata()
     
    },
    methods:{
        async getdata(){
            let res = await this.$api.getSupplierinfo();
            this.supplierinfo = res.data.data
            // console.log('this.supplierinfo',this.supplierinfo)
        },
    }
}
</script>
<style lang="less" scoped>
page{width: 100%;}
.layout {
    width: 100%;
    background-color: #012430;
    .menu {
        width: 20%;
        min-width: 380px;
        background-image: url('https://kaifaceshi.08170817.com/static/admin/menubgi.png');
        background-size: 100% 100%;
        background-color: #012430;
        padding: 5px 0 0 0;
        height: 60%;
        margin: 0 10px;
    }
    .content {
        margin-right: 30px;
        width: 75%;
    }

    .small {
        padding-left: 64px;
    }
}
</style>